<div class="flex-row flex-auto">

    <div class="flex-fill left-column flex-scroll">
        <div class="header-name">Category</div>
        <ng-container *ngFor="let category of categories">
            <div class="item" (click)="onSelectCategory(category)" [ngClass]="{'active': category?.name == selectedCategory?.name}">
                {{category?.name}}
            </div>
        </ng-container>
    </div>

    <div class="flex-fill right-column flex-scroll">

        <ng-container *ngIf="selectedCategory">
            <div class="header-name">
                Subcategory
            </div>

            <div class="item" *ngFor="let sub of selectedCategory?.subCategories" (click)="onSelectSubCategory(sub)" [ngClass]="{'active': sub?._id == selectedSubcategory?._id }">
                <ng-container *ngIf="sub?._id === selectedCategory?._id; else elseTemplate">
                    <span #selectedItem>{{sub?.name}}</span>
                </ng-container>
                <ng-template #elseTemplate>
                    <span>{{sub?.name}}</span>
                </ng-template>
            </div>
        </ng-container>




    </div>

</div>